import { store } from '../../../../../../redux/store';
import {
  getCurrentCompany,
  getCurrentProject
} from '../../../../../../utils/userUtils';
/**
 * Generates the HTML for displaying the company logo image.
 *
 * @param {string} imgCompany - The URL of the company logo image.
 * @param {boolean} [showImage=true] - Whether to display the image or not. Defaults to true.
 * @returns {string} The HTML string for the company logo image or a placeholder div if no image is provided.
 */
const getImageCompanyHTML = (imgCompany, showImage = true) => {
  if (imgCompany && showImage) {
    return `<img src="${imgCompany}" class="img-company imagen-custom-logo" />`;
  }
  return '<div style="height:100%; width:50px"></div>';
};

/**
 * Generates the HTML for displaying the project owner's image.
 *
 * @param {string} imageProjectOwner - The URL of the project owner's image.
 * @param {boolean} [showImage=true] - Whether to display the image or not. Defaults to true.
 * @returns {string} The HTML string for the project owner's image or a placeholder span if no image is provided.
 */
const getImageProjectOwnerHTML = (imageProjectOwner, showImage = true) => {
  if (imageProjectOwner && showImage) {
    return `<img src="${imageProjectOwner}" class="img-owner imagen-custom-owner" />`;
  }
  return '<span class="header-right"><div style="height:5px; width:30px"></div></span>';
};

/**
 * Retrieves the image owner of the current project.
 *
 * @returns {string | undefined} The image owner of the current project, or `undefined` if not found.
 */
const getImageOwner = () => {
  const projects = store.getState().projectState?.allProjects;
  const { id: projectId } = getCurrentProject();

  const project = projects.find(({ id }) => id === projectId);
  if (!project) return;
  const { imageProjectOwner } = project;
  return imageProjectOwner;
};

/**
 * Generates the HTML for the header section of the PDF export.
 *
 * @param {Object} config - The configuration object containing the following properties:
 * @param {string} config.title - The title to be displayed in the PDF header.
 * @param {string} config.subtitle - The subtitle to be displayed in the PDF header.
 * @param {boolean} config.showOwnerLogo - Whether to display the owner logo or not.
 * @param {boolean} config.showOrganizationLogo - Whether to display the organization logo or not.
 *
 * @returns {string} The HTML string representing the header, including the company logo, project name, sector name, and project owner's image.
 */
export const getHeaderPDF = ({
  title,
  subtitle,
  showOwnerLogo,
  showOrganizationLogo
}) => {
  const { image: imgCompany } = getCurrentCompany();
  const imageOwner = getImageOwner();

  const imageCompanyHTML = getImageCompanyHTML(
    imgCompany,
    showOrganizationLogo
  );
  const imageProjectOwnerHTML = getImageProjectOwnerHTML(
    imageOwner,
    showOwnerLogo
  );

  return `
    <div class="wrapper-pdf">
        ${imageCompanyHTML}
        <div class="wrapper-pdf-company">
            <span class="gantt-header-title-project">${title}&nbsp;</span>
            <span class="gantt-header-title-sector">${subtitle}&nbsp;</span>
        </div>
        ${imageProjectOwnerHTML}
    </div>
  `;
};
